import React from 'react';
import bespokeServerAppMockupsHtml from './bespokeServerAppMockupsHtml';

const BespokeServerAppMockups: React.FC = () => {
  return (
    <iframe
      srcDoc={bespokeServerAppMockupsHtml}
      title="Bespoke Server App — Style Explorations"
      style={{ width: '100%', height: '100vh', border: 'none' }}
    />
  );
};

export default BespokeServerAppMockups;
